import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import TransactionHttpService from '../../services/transaction.http';
import { historyPush } from '../../common/history';

export function* GET({ payload }) {
  yield put({
    type: actions.transaction.SET_STATE,
    payload: {
      selected_transaction: null,
      loading: true
    }
  });

  const response = yield call(TransactionHttpService.get, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.transaction.SET_STATE,
        payload: {
          selected_transaction: response.data
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: false }
  });
}

export function* GET_MY_LIST({ payload }) {
  yield put({
    type: actions.transaction.SET_STATE,
    payload: {
      transactions: [],
      loading: true
    }
  });

  const response = yield call(TransactionHttpService.getMyList, payload);
  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.transaction.SET_STATE,
        payload: {
          transactions: [...response.data]
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: false }
  });
}

export function* CHARGE({ payload }) {
  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(TransactionHttpService.charge, payload);
  if (response) {
    if (response.status < 400) {
      const { transaction } = yield select();
      const index = transaction.transactions.findIndex(
        o => o.uid,
        payload.transaction_uid
      );
      transaction.transactions[index].payment_status = 0;
      transaction.selected_transaction.transaction.payment_status = 0;
      yield put({
        type: actions.transaction.SET_STATE,
        payload: {
          selected_transaction: transaction.selected_transaction,
          transactions: [...transaction.transactions]
        }
      });

      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'success',
          message: 'transaction has been charged successfully!'
        }
      });

      yield put({
        type: actions.cart.INIT
      });
      historyPush(`/order/${payload.transaction_uid}/details`);
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: false }
  });
}

export function* CREATE({ payload }) {
  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(TransactionHttpService.create, payload);
  if (response) {
    if (response.status < 400) {
      const { transaction } = yield select();
      if (transaction.transactions.length > 0) {
        yield put({
          type: actions.transaction.SET_STATE,
          payload: {
            transactions: [...response.data, ...transaction.transactions]
          }
        });
      }

      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'success',
          message: 'transaction has been created successfully!'
        }
      });

      yield put({
        type: actions.cart.INIT
      });
      historyPush('/orders');
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: false }
  });
}

export function* CHARGE_CREATE({ payload }) {
  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(TransactionHttpService.chargeAndCreate, payload);
  if (response) {
    if (response.status < 400) {
      const { transaction } = yield select();
      if (transaction.transactions.length > 0) {
        yield put({
          type: actions.transaction.SET_STATE,
          payload: {
            transactions: [...response.data, ...transaction.transactions]
          }
        });
      }

      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'success',
          message: 'transaction has been charged and created successfully!'
        }
      });

      yield put({
        type: actions.cart.INIT
      });
      historyPush('/orders');
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.transaction.SET_STATE,
    payload: { loading: false }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.transaction.GET, GET),
    takeEvery(actions.transaction.GET_MY_LIST, GET_MY_LIST),
    takeEvery(actions.transaction.CREATE, CREATE),
    takeEvery(actions.transaction.CHARGE, CHARGE),
    takeEvery(actions.transaction.CHARGE_CREATE, CHARGE_CREATE)
  ]);
}
